import { createContext, RefObject, useContext } from 'react';

/**
 * Portal target for Ambrosia overlays (Modal, Sidebar).
 *
 * When a provider supplies a container ref, `Dialog.Portal` renders overlays into
 * that element instead of `<body>`. If the element forms a containing block (e.g.
 * via `transform`) and clips overflow, the fixed backdrop/popup are confined to
 * it — so an overlay sits beside a sibling panel (e.g. the Agent Dave chat) rather
 * than covering it.
 *
 * With no provider present the value is `null`, so overlays fall back to
 * portalling into `<body>` — Base UI's default, fully backward-compatible.
 */
const OverlayPortalContainerContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

export const OverlayPortalContainerProvider =
  OverlayPortalContainerContext.Provider;

/** Returns the overlay portal container ref, or `null` when no provider is present. */
export const useOverlayPortalContainer = () =>
  useContext(OverlayPortalContainerContext);
